interface Props {
  mode: 'edit' | 'preview';
  onModeChange: (m: 'edit' | 'preview') => void;
  onPrint: () => void;
  onExportHtml: () => void;
  docName: string;
  onDocNameChange: (s: string) => void;
  saving: boolean;
}

export function Toolbar({ mode, onModeChange, onPrint, onExportHtml, docName, onDocNameChange, saving }: Props) {
  return (
    <header className="cb-toolbar">
      <div className="cb-toolbar-left">
        <span className="cb-app-brand">Composer<span className="cb-dot">.</span></span>
        <input
          className="cb-doc-title"
          value={docName}
          onChange={(e) => onDocNameChange(e.target.value)}
          spellCheck={false}
        />
        <span className={`cb-save-state ${saving ? 'is-saving' : ''}`}>
          {saving ? 'Saving…' : 'Saved'}
        </span>
      </div>
      <div className="cb-toolbar-right">
        <div className="cb-segment">
          <button type="button"
            className={mode === 'edit' ? 'is-active' : ''}
            onClick={() => onModeChange('edit')}>Edit</button>
          <button type="button"
            className={mode === 'preview' ? 'is-active' : ''}
            onClick={() => onModeChange('preview')}>Preview</button>
        </div>
        <button type="button" className="cb-btn" onClick={onExportHtml}>Export HTML</button>
        <button type="button" className="cb-btn cb-btn-primary" onClick={onPrint}>Print</button>
      </div>
    </header>
  );
}
